module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form class="form-horizontal" id="' +
((__t = (id)) == null ? '' : __t) +
'">\n    <div class="form-group row">\n        <label class="DescartesUILabel col-sm-6 col-form-label">' +
((__t = (label)) == null ? '' : __t) +
'</label>\n        <div class="col-sm-6">\n        	<input type="number" required="true" class="DescartesUIInput form-control" id="' +
((__t = (id)) == null ? '' : __t) +
'_input" name="choosedScale" min="' +
((__t = (min)) == null ? '' : __t) +
'" max="' +
((__t = (max)) == null ? '' : __t) +
'">\n        </div>\n    </div>\n    <button type="submit" class="DescartesUIButtonSubmit btn ' +
((__t = (btnCssSubmit)) == null ? '' : __t) +
'">' +
((__t = (buttonMessage)) == null ? '' : __t) +
'</button>\n</form>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/ScaleChooser.ejs
// module id = 413
// module chunks = 0